import { render, staticRenderFns } from "./PopupContainer.vue?vue&type=template&id=ef444bdc&scoped=true&"
import script from "./PopupContainer.vue?vue&type=script&lang=js&"
export * from "./PopupContainer.vue?vue&type=script&lang=js&"
import style0 from "./PopupContainer.vue?vue&type=style&index=0&id=ef444bdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef444bdc",
  null
  
)

export default component.exports